import { render, staticRenderFns } from "./WalletLink.vue?vue&type=template&id=8a1baf6c&scoped=true"
import script from "./WalletLink.vue?vue&type=script&lang=js"
export * from "./WalletLink.vue?vue&type=script&lang=js"
import style0 from "./WalletLink.vue?vue&type=style&index=0&id=8a1baf6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1baf6c",
  null
  
)

export default component.exports